import axios from "axios";

const url = `${process.env.REACT_APP_API_DOMAIN}api`;
const token = window.localStorage.getItem("@jsonWepToken");
const config = {
  headers: { Authorization: `Bearer ${token}` }
};

const packageData = (data) => {
  const form = new FormData();
  for (const key in data) {
    if (Array.isArray(data[key])) {
      for (const childKey in data[key]) {
        form.append(`${key}[${childKey}]`, data[key][childKey]);
      }
    } else {
      form.append(key, data[key]);
    }
  }
  return form;
};

const requests = {
  authPassword: (username) =>
    axios.post(`${url}/clients/login-register`, username),
  authLogin: (username) => axios.post(`${url}/clients/verify`, username),
  getMe: () => axios.get(`${url}/users/me`, config),
  updateProfile: (params) =>
    axios.patch(`${url}/users/me`, packageData(params), config),

  // Product
  fetchProducts: (params) =>
    axios.get(`${url}/products`, { params, ...config }),
  fetchProductsStream: (params) =>
    axios.get(`${url}/products?filters[in_stream]=true`, { params, ...config }),
  fetchProductOne: (id) => axios.get(`${url}/products/${id}`, config),

  // Order
  createOrder: (params) => axios.post(`${url}/orders/quick`, params),
  updateOrderNew: (id) =>
    axios.post(`${url}/orders/${id}/recheck`, null, config),
  orderChartStreamState: (id) => axios.get(`${url}/orders/stream-income/${id}`),
  orderUpdatePending: (id) =>
    axios.put(`${url}/orders/${id}/pending`, null, config),

  // Stream
  fetchStreamClent: (params) =>
    axios.get(`${url}/streams`, { params, ...config }),
  fetchStreamStatistic: () => axios.get(`${url}/streams/statistics`, config),
  fetchByStreamStatistic: (params) =>
    axios.get(`${url}/streams/statistics/by-stream`, { params, ...config }),
  createStream: (params) => axios.post(`${url}/streams/join`, params, config),
  deleteStream: (id) => axios.delete(`${url}/streams/${id}`, config),
  updateStreamAgent: (id, data) =>
    axios.patch(`${url}/streams/${id}`, data, config),
  updateStreamAgentDelivery: (id, data) =>
    axios.patch(`${url}/streams/${id}`, data, config),

  // Transaction request
  fetchPaymentRequest: () => axios.get(`${url}/payment-requests`, config),
  createPaymentRequest: (params) =>
    axios.post(`${url}/payment-requests`, params, config),
  fetchTransactions: (params) =>
    axios.get(`${url}/transactions`, { params, ...config }),

  // Locations
  getLocations: () => axios.get(`${url}/regions`),

  // Category
  fetchCatigory: () => axios.get(`${url}/categories`),

  // Locations
  fetchProductWiew: () => axios.get(`${url}/products/most/view/products`),

  // Locations
  fetchAgentOrders: (params) =>
    axios.get(`${url}/streams/orders`, { params, ...config }),
  fetchBestSellingProduct: () =>
    axios.get(`${url}/orders/best/selling/products`),
  fetchContestState: () => axios.get(`${url}/contest/state`, config),
  fetchContestParticipants: () =>
    axios.get(`${url}/contest/participants`, config),
  fetchContestJoin: () => axios.post(`${url}/contest/join`, null, config)
};

axios.interceptors.response.use(
  (response) => {
    // Oddiy response qaytarish
    return response;
  },
  async (error) => {
    console.error("Xatolik:", error);

    // 401 status kodi - autentifikatsiya xatosi
    if (error.response?.status === 401) {
      window.localStorage.removeItem("@jsonWebTokenManager");
      window.location.reload();
      return Promise.reject(error);
    }

    // Agar 406 status kodi bo'lmasa, xatolikni qaytarish
    if (error.response?.status !== 406) {
      return Promise.reject(error);
    }

    // Refresh token olish
    const refreshToken = window.localStorage.getItem("@jsonWepRefreshToken");

    if (!refreshToken) {
      // Agar refresh token mavjud bo'lmasa, xatolikni qaytarish
      return Promise.reject(error);
    }

    try {
      // Refresh token orqali yangi access token olish
      const { data } = await axios.post(`${url}/users/refresh`, {
        refreshToken
      });

      if (data?.data?.token) {
        // Yangi tokenni localStorage'ga saqlash
        window.localStorage.setItem("@jsonWepToken", data.data.token);

        // Original requestni yangilash
        error.config.headers["Authorization"] = `Bearer ${data.data.token}`;

        // Yangi token bilan so'rovni qayta yuborish
        const response = await axios.request(error.config);
        return response;
      }

      // Agar token olinmasa, xatolikni qaytarish
      return Promise.reject(error);
    } catch (err) {
      console.error("Refresh token xatolik:", err);
      return Promise.reject(err);
    }
  }
);

export default requests;
